import React from "react";
import FetchHelper from "./lib/fetchHelper.js";
export default class EventTicketSalesComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
        this.getTicketSales = this.getTicketSales.bind(this);
    }
    componentDidMount() {
        this.getTicketSales();
    }
    componentWillUnmount() {
        clearTimeout(this.token);
    }
    getTicketSales() {
        this.setState({ isLoaded: false });
        FetchHelper.get(`/bpapi/eventinfo/${this.props.eventid}/tickets`)
            .then((result) => {
            this.setState({ ticketSales: result, isLoaded: true });
        })
            .catch(error => this.setState({ ticketSales: null, islLoaded: true }));
        this.token = setTimeout(this.getTicketSales, 60000);
    }
    render() {
        var sales = this.state.ticketSales;
        if (this.state.isLoaded) {
            return (React.createElement(React.Fragment, null, (sales)
                ? (React.createElement("span", null,
                    React.createElement("strong", null, sales.sold),
                    " solgte, ",
                    sales.prebooked,
                    " reserverede, ",
                    sales.free,
                    " ledige"))
                : (React.createElement("span", null,
                    React.createElement("i", { className: "fas fa-exclamation-triangle" })))));
        }
        return (React.createElement("span", null,
            React.createElement("i", { className: "fas fa-spinner fa-pulse" })));
    }
}
